<mat-nav-list class="app-sidenav pb-0">

	<mat-divider></mat-divider>

	<a mat-list-item routerLink="/" (click)="toggleVisibility.emit()">
		<mat-icon matListItemIcon svgIcon="home-solid"></mat-icon>
		<p matListItemLine class="app-sidenav__item" i18n>Startseite</p>
	</a>

	<mat-divider></mat-divider>

	<a mat-list-item *ngIf="userInfo?.anonymous === false"
		 target="_blank" [href]="'change-password' | resourcePath">
		<mat-icon matListItemIcon svgIcon="person-solid"></mat-icon>
		<p matListItemLine class="app-sidenav__item">{{userInfo?.fullName}}
			<ng-container *ngIf="userInfo?.companyName"> / {{userInfo?.companyName}}</ng-container>
		</p>
	</a>

	<mat-divider></mat-divider>

	<a mat-list-item *ngIf="userInfo?.groupAdminUrl as groupAdminUrl"
		 target="_blank" [href]="groupAdminUrl">
		<mat-icon matListItemIcon svgIcon="person-solid"></mat-icon>
		<p matListItemLine class="app-sidenav__item" i18n>Gruppenverwaltung</p>
	</a>

	<a mat-list-item *ngIf="userInfo?.anonymous === true" class="app-sidenav__login"
		 [href]="'login' | resourcePath">
		<mat-icon matListItemIcon svgIcon="person-solid"></mat-icon>
		<p matListItemLine class="app-sidenav__item" i18n>Login</p>
	</a>


	<mat-divider></mat-divider>

	<a mat-list-item (click)="showLanguages.next(!showLanguages.value)">
		<mat-icon matListItemIcon svgIcon="globe-glyph"></mat-icon>
		<p matListItemLine class="app-sidenav__item" i18n>Sprache wählen</p>
	</a>

	<mat-divider *ngIf="userInfo?.anonymous === false"></mat-divider>

	<div *ngIf="showLanguages.value">
		<a mat-list-item (click)="languageService.changeLanguage('de')">
			<mat-icon matListItemIcon></mat-icon>
			<p matListItemLine class="app-sidenav__item">Deutsch</p>
		</a>

		<mat-divider></mat-divider>

		<a mat-list-item (click)="languageService.changeLanguage('en')">
			<mat-icon matListItemIcon></mat-icon>
			<p matListItemLine class="app-sidenav__item">English</p>
		</a>

		<mat-divider></mat-divider>

		<a mat-list-item (click)="languageService.changeLanguage('fr')">
			<mat-icon matListItemIcon></mat-icon>
			<p matListItemLine class="app-sidenav__item">Français</p>
		</a>

		<mat-divider></mat-divider>

		<a mat-list-item (click)="languageService.changeLanguage('es')">
			<mat-icon matListItemIcon></mat-icon>
			<p matListItemLine class="app-sidenav__item">Español</p>
		</a>

		<mat-divider></mat-divider>

		<a mat-list-item (click)="languageService.changeLanguage('it')">
			<mat-icon matListItemIcon></mat-icon>
			<p matListItemLine class="app-sidenav__item">Italiano</p>
		</a>
	</div>

	<form *ngIf="userInfo?.anonymous === false"
				[action]="'logout' | resourcePath"
				class="app-sidenav__logout"
				#logoutForm>
		<a mat-list-item (click)="logoutForm.submit()">
			<mat-icon matListItemIcon svgIcon="material-logout"></mat-icon>
			<p matListItemLine class="app-sidenav__item" i18n>Logout</p>
		</a>
	</form>
</mat-nav-list>
